import React from 'react'
import { Layout } from './Layout'
import { ListViewProvider } from './Context'

export const ListView = () => {
  return (
    <ListViewProvider>
      <Layout />
    </ListViewProvider>
  )
}
